<template>
  <!-- Document -->
  <div v-if="category == document.section_id || category == 0 "
    class="col-md-4 col-sm-6 col-xs-1 images ag mb-4 dlnkdocs_section" :class="'dlnkdocs_section_' + document.section_id">

    <div class="card card-frame h-100" href="#">
      <div class="card-body pb-3 pt-4">
        <div class="row">
          <figure class="w-100 mb-3 col-3">
            <span class="text-primary"><i class="far fa-file-image fa-3x"></i></span>
          </figure>
          <div class="text-right col-9">
            <small class="d-block text-default mt-1"> <span class="text-dark">{{ document.author }}</span></small>
            <small class="d-block text-default mt-1">le <span class="text-dark">{{ document.updated_at }}</span></small>
          </div>
        </div>

        <h4 class="cbp-l-grid-projects-title">{{ document.title }}</h4>
        <p class="font-size-1 text-body mb-0">{{ document.description }}</p>

      </div>
      <div class="card-footer border-0 pt-0 ml-2 mr-2">
        <div class="row">
          <a class="btn btn-sm btn-soft-primary btn-pill transition-3d-hover col-12" :href="document.url" v-if="document.type == 1" download="">
            <i class="fas fa-download"></i>&nbsp;Télécharger
          </a>

          <a data-fancybox class="btn btn-sm btn-soft-primary btn-pill transition-3d-hover col-12"
             :href="document.video_url" v-if="document.type == 2">
            <i class="fas fa-eye"></i>&nbsp;Visionner
          </a>
        </div>
      </div>

      <div v-if="!!is_admin" class="card-footer border-0 pt-0 ml-2 mr-2">
        <div class="row">
          <a @click='edit_document()'   class="btn btn-sm btn-soft-dark btn-pill transition-3d-hover col-6" href="javascript:"><i class="fas fa-cogs"></i></a>
          <a @click='delete_document()' class="btn btn-sm btn-soft-danger btn-pill transition-3d-hover col-6" href="javascript:" download=""><i class="fas fa-trash"></i></a>
        </div>
      </div>

    </div>
  </div>
  <!-- End Document -->
</template>

<script>
    export default {
      props: {
        document: Object,
        category: Number,
        is_admin: Boolean,
        company: Object,
      },
      mounted() {
        
      },

      methods: {
        edit_document: function () {
          this.$emit('edit_document', this.document)
        },
        delete_document: function () {
          this.$emit('delete_document', this.document.id)
        },

      }
    }
</script>

